import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import orderServices from '../../services/orders/orderservice'; 

interface UserOption {
    userID: number;
    name: string;
    primaryContactNbr: string;
}

interface DropdownItem {
    userID: number;
    detail: string;
}

const RoleAccessSearch: React.FC<{ onSearch: (userId: number | null) => void }> = ({ onSearch }) => {
    const blankUserList: UserOption[] = [{ userID: 0, name: '', primaryContactNbr: '' }];
    const [orderUsers, setOrderUsers] = useState<UserOption[]>(blankUserList);
    const [dropdownItems, setDropdownItems] = useState<DropdownItem[]>([]);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);

    const handleDropdownFilter = (e: any) => {
        const filterValue = e.filter?.trim();
        if (filterValue && filterValue.length > 2) {
            orderServices.getOrderUsers(filterValue)
                .then((response: UserOption[]) => {
                    setOrderUsers(response.length > 0 ? response : blankUserList);
                })
                .catch(error => {
                    console.error("Error fetching users:", error);
                    setOrderUsers(blankUserList);
                });
        }
    };

    // Handle dropdown selection
    const handleDropdownChange = (e: any) => {
        setSelectedUserId(e.value || null);
    };

    // Trigger search
    const handleSearchClick = () => {
        onSearch(selectedUserId);
    };

    // Convert raw users to dropdown display format
    useEffect(() => {
        const formatted = orderUsers.map(user => ({
            userID: user.userID,
            detail: user.userID !== 0 ? `${user.name}, ${user.primaryContactNbr}` : ''
        }));
        setDropdownItems(formatted);
    }, [orderUsers]);

    return (
        <div className="col-5">
            <div className="card border-noround p-3">
                <div className="flex align-items-center gap-3">
                    <div className="flex align-items-center gap-2 flex-grow-1">
                        <label className="font-bold mr-2" style={{ minWidth: '50px' }}>User:</label>
                        <Dropdown
                            value={selectedUserId}
                            options={dropdownItems}
                            optionLabel="detail"
                            optionValue="userID"
                            onChange={handleDropdownChange}
                            onFilter={handleDropdownFilter}
                            filter
                            placeholder="Search for User/Mobile"
                            className="w-full"
                        />
                    </div>
                    <div className="flex-shrink-0">
                        <Button
                            label="Search"
                            icon="pi pi-search"
                            className="p-button-primary"
                            onClick={handleSearchClick}
                            disabled={!selectedUserId}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoleAccessSearch;
